import type { Template } from './tipos';

/**
 * Os templates que a vitrine conhece, cada um no seu pedaço de código.
 *
 * Location: src/templates
 * Why: o `import()` deixa cada template num arquivo separado do build, então
 * uma loja no clássico não baixa o código (nem o CSS) do aurora. A lista de
 * ids tem de bater com `TEMPLATES_DA_LOJA` da API e com o catálogo do painel.
 */
export const CARREGADORES: Record<string, () => Promise<{ default: Template }>> = {
  classico: () => import('./classico'),
  aurora: () => import('./aurora'),
  celeste: () => import('./celeste'),
  prisma: () => import('./prisma'),
  personalizado: () => import('./personalizado'),
  code: () => import('./code'),
};

export const TEMPLATE_PADRAO = 'classico';

/** O id que a vitrine vai usar: desconhecido ou ausente vira o clássico. */
export function idDoTemplate(id: string | null | undefined): string {
  return id && Object.prototype.hasOwnProperty.call(CARREGADORES, id) ? id : TEMPLATE_PADRAO;
}

/**
 * Carrega o template da loja. Se o pedaço não baixar (rede caiu no meio de um
 * deploy, por exemplo), a loja abre no clássico em vez de ficar em branco.
 */
export async function carregarTemplate(id: string | null | undefined, loja?: { id: string }): Promise<Template> {
  const escolhido = idDoTemplate(id);
  try {
    const template = (await CARREGADORES[escolhido]()).default;
    if (!template.preparar) return template;
    // O Personalizado e o tema em código buscam o que foi publicado; sem isso, o `catch` abaixo abre o clássico.
    const pronto = loja ? await template.preparar(loja) : null;
    if (!pronto) throw new Error('template sem o que desenhar');
    return pronto;
  } catch {
    return (await CARREGADORES[TEMPLATE_PADRAO]()).default;
  }
}
